<template>
    <div class="model-detail" v-if="pageData">
        <section class="model-name" @click="handleBack">
            <span class="arrow iconfont icon-arrow_left_model"></span>
            <span class="name">
                {{
                    !pageData.isMobile
                        ? `${pageData.last_name} ${pageData.first_name}`
                        : "BACK"
                }}
            </span>
        </section>
        <section class="model-info">
            <section class="model-tab" v-if="showTabList">
                <div
                    @click="handleTab(im, ix)"
                    :class="[
                        'model-tab-item',
                        { active: currentTab == ix + 1 },
                    ]"
                    v-for="(im, ix) in tabList"
                    :key="ix"
                >
                    <div
                        class="cover"
                        :style="{ 'background-image': `url(${im.img})` }"
                    ></div>
                    <div class="desc">
                        {{ im.title.toUpperCase() }}
                    </div>
                </div>
            </section>
            <section
                :class="[
                    'model-show',
                    {
                        'mobile-current-show': currentTab,
                        homepage: step === 1 && $store.state.cw > 768,
                        'image-banner': type && type !== 'video' && $store.state.cw > 768,
                        'margin-flexible':
                            step === 2 &&
                            $store.state.cw / $store.state.ch > 1600 / 1002,
                    },
                ]"
            >
                <!-- currentTab 存在时显示 -->
                <!-- <div v-if="currentTab" class="model-media__wrapper"> -->
                <div
                    v-if="step === 2"
                    class="model-media__wrapper"
                    :class="{
                        video: type === 'video'
                    }"
                >
                    <!-- mobile显示tab -->
                    <div class="mobile-show-tab" v-if="pageData.isMobile">
                        <div
                            :class="[
                                'mobile-tab-item',
                                { active: currentTab == ix + 1 },
                            ]"
                            v-for="(im, ix) in tabList"
                            :key="ix"
                            @click="handleTab(im, ix)"
                        >
                            {{ im.title.toUpperCase() }}
                        </div>
                    </div>
                    <!-- 模特参数 -->
                    <!-- <div class="current-show" v-if="!pageData.isMobile">
                        <div class="info">
                            <div class="name">
                                {{ pageData.last_name }}
                                {{ pageData.first_name }}
                            </div>
                            <div class="height">{{ pageData.height }}CM</div>
                            <div class="three">
                                {{ pageData.bust }}/{{ pageData.waistline }}/{{
                                    pageData.hipline
                                }}
                            </div>
                            <div class="size">{{ pageData.shoe_size }}</div>
                        </div>
                        <div class="contact">
                            <div
                                v-if="pageData.weibo"
                                class="icon iconfont icon-social_weibo"
                                @click="handleJump('weibo')"
                            ></div>
                            <div
                                v-if="pageData.xiaohongshu"
                                class="icon iconfont icon-social_xiaohongshu"
                                @click="handleJump('xiaohongshu')"
                            ></div>
                            <div
                                v-if="pageData.ins"
                                class="icon iconfont icon-social_ins"
                                @click="handleJump('ins')"
                            ></div>
                        </div>
                    </div> -->

                    <!-- 非视频类 -->
                    <template v-if="type != 'video'">
                        <!-- 轮播 -->
                        <div class="current-show-info">
                            <swiper
                                :options="swiperOptions"
                                ref="picSwiper"
                                class="current-swiper"
                            >
                                <swiper-slide
                                    v-for="(item, index) in showInfoData.list"
                                    :key="index"
                                    class="swiper-item"
                                >
                                    <!-- :style="{
                                        'background-image': `url(${item.link})`,
                                    }" -->
                                    <div class="profile-img" :style="{ backgroundImage: `url(${item.link})`}">
                                        <!-- <img
                                            :src="item.link"
                                            class="img"
                                        /> -->
                                        <!-- 模特其他说明 -->
                                        <div
                                            v-if="item.textarea"
                                            class="profile-intro"
                                            v-html="item.textarea"
                                        ></div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="prev iconfont icon-arrow_left"></div>
                            <div class="next iconfont icon-arrow_right"></div>
                        </div>

                        <!-- 翻页 -->
                        <div class="current-num">
                            <template v-if="pageData.isMobile">
                                <span class="first-num">{{
                                    currentIndex
                                }}</span>
                                <span>/</span>
                                <span class="second-num">{{
                                    showInfoData.list.length
                                }}</span>
                            </template>

                            <template v-else>
                                <span class="first-num">
                                    {{
                                        currentIndex / 2 !== 0
                                            ? (currentIndex + 1) / 2
                                            : currentIndex / 2
                                    }}
                                </span>
                                <span>/</span>
                                <span class="second-num">{{
                                    showInfoData.list.length / 2
                                }}</span>
                            </template>
                            <!-- <div class="iconfont icon-arrow_left prev"></div>
                            <div class="iconfont icon-arrow_right next"></div> -->
                        </div>
                    </template>

                    <!-- 视频 -->
                    <media-swiper
                        v-else-if="type === 'video' && showInfoData.list.length"
                        type="detail"
                        urlKey="link"
                        pagination-type="fraction"
                        :list="showInfoData.list"
                    />
                </div>

                <!-- 主页展示 -->
                <div class="init-show" v-else>
                    <div
                        class="cover"
                        :style="{ 'background-image': `url(${pageData.link})` }"
                    ></div>
                    <div class="intro">
                        <div class="intro-name">
                            {{ pageData.last_name }} {{ pageData.first_name }}
                        </div>
                        <div class="intro-other">
                            <div class="height">{{ pageData.height }}CM</div>
                            <div class="three">
                                {{ pageData.bust }}/{{ pageData.waistline }}/{{
                                    pageData.hipline
                                }}
                            </div>
                            <div class="size">{{ pageData.shoe_size }}</div>
                            <!-- <div
                                class="intro-other-item"
                                v-for="(item, prop) in modelIntro"
                                :key="prop"
                            >
                                <span class="prop">{{ prop }}“</span>
                                <span>{{ item }}{{ prop == 'height' ? 'cm' : '' }}</span>
                            </div> -->
                        </div>
                        <div class="intro-method">
                            <div
                                class="icon iconfont icon-social_weibo"
                                @click="handleJump('weibo')"
                                v-if="pageData.weibo"
                            ></div>
                            <div
                                class="icon iconfont icon-social_xiaohongshu"
                                @click="handleJump('xiaohongshu')"
                                v-if="pageData.xiaohongshu"
                            ></div>
                            <div
                                class="icon iconfont icon-social_ins"
                                @click="handleJump('ins')"
                                v-if="pageData.ins"
                            ></div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>

<script>
import MediaSwiper from '@/components/feature/MediaSwiper.vue';

export default {
    name: 'detail',

    components: {
        MediaSwiper,
    },

    data() {
        return {
            pageData: null,
            tabList: [
                {
                    title: 'portfolio',
                },
                {
                    title: 'campaign',
                },
                {
                    title: 'cover',
                },
                {
                    title: 'show',
                },
                {
                    title: 'video',
                },
            ],
            currentTab: '',
            type: '',
            modelIntro: {
                height: '',
                bust: '',
                waistline: '',
                hipline: '',
            },
            // 轮播
            currentIndex: 1,
            swiperOptions: {
                slidesPerView: this.$store.state.cw > 768 ? 2 : 1,
                slidesPerGroup: this.$store.state.cw > 768 ? 2 : 1,
                navigation: {
                    prevEl: '.icon-arrow_left',
                    nextEl: '.icon-arrow_right',
                    disabledClass: 'hidden',
                },
                on: {
                    slideChange: () => {
                        this.currentIndex =
                            this.$refs.picSwiper.swiper.realIndex + 1;
                    },
                },
            },
            step: 1,
        };
    },

    computed: {
        showInfoData() {
            return this.tabList[this.currentTab - 1];
        },
        showTabList() {
            if (this.tabList.length > 0 && !this.pageData.isMobile) return true;
            if (
                this.tabList.length > 0 &&
                this.pageData.isMobile &&
                !this.currentTab
            ) {
                return true;
            }
            return false;
        },
    },

    watch: {
        $route() {
            this.$router.go(0);
        },
    },

    methods: {
        handleTab(im, ix) {
            this.currentTab = ix + 1;
            this.type = im.title;
            this.currentIndex = 1;
            this.step = 2;
            if (this.type !== 'video') {
                this.$nextTick(() => {
                    this.currentIndex = 1;
                    this.$refs.picSwiper.swiper.slideTo(0, 0);
                });
            }
        },
        handleBack() {
            if (this.step === 2) {
                this.step = 1;
                this.currentTab = '';
                // this.showTabList = true;
            } else {
                this.$router.push({name: 'home'});
            }
        },
        toPlays() {},
        updateTime() {},
        toPause() {},

        fetchDetail() {
            this.$http
                .getModelDetail({
                    id: this.$route.params.id,
                })
                .then((res) => {
                    res.isMobile = this.$store.state.cw <= 768;
                    this.pageData = res;

                    Object.keys(this.modelIntro).forEach((key) => {
                        if (res[key]) this.modelIntro[key] = res[key];
                    });

                    this.tabList.map((el) => {
                        if (res[el.title]) {
                            el.img = res[el.title].image;
                            const len = res[el.title].list.length;
                            if (
                                len % 2 !== 0 &&
                                !this.pageData.isMobile &&
                                el.title !== 'video'
                            ) {
                                res[el.title].list.push({ link: '' });
                            }
                            el.list = res[el.title].list.map((ele) => {
                                if (ele.textarea) {
                                    ele.textarea = ele.textarea.replace(
                                        /\n/g,
                                        '<br/>'
                                    );
                                    ele.textarea = ele.textarea.replace(
                                        / /g,
                                        ' &nbsp'
                                    );
                                }
                                return ele;
                            });
                        }
                        return el;
                    });
                    this.tabList = this.tabList.filter((el) => el.list && el.list.length > 0);
                });
        },

        handleJump(prop) {
            const url = this.pageData[prop];
            window.open(url);
        },
    },

    created() {
        this.fetchDetail();
    },
};
</script>

<style lang="scss" scoped>
.hidden {
    display: none;
}

.model-detail {
    width: 100%;
    height: calc(100vh - 130px);
    overflow: hidden;
    padding: 22px 0 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    @include media-mob {
        padding: 0;
        height: auto;
    }
    // justify-content: space-between;
}
.model-name {
    display: flex;
    align-items: center;
    cursor: pointer;
    @include media-mob {
        padding: 0 20px;
        box-sizing: border-box;
    }
    span {
        display: inline-block;
    }
    .arrow {
        font-size: 22px;
        @include media-mob {
            font-size: 14px;
        }
    }
    .name {
        margin-left: 20px;
        font-size: 30px;
        font-family: Didot-Bold, Didot;
        font-weight: bold;
        color: #ba9153;
        line-height: 30px;
        @include media-mob {
            font-size: 20px;
            margin-left: 10px;
        }
    }
}
.model-info {
    // padding-top: 88px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex: 1;

    @include media-mob {
        flex-direction: column-reverse;
        padding-top: 20px;
    }
}
.model-tab {
    width: 340px;
    padding-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 0 0 auto;
    // margin: 0 154px 0 0;
    @include media-mob {
        width: 100%;
        margin: 0;
        padding: 0;
    }
    &-item {
        display: flex;
        align-items: center;
        margin: 0 0 28px;
        cursor: pointer;
        &:last-child {
            margin: 0;
        }
        @include media-mob {
            width: 100%;
            margin: 0;
            padding: 30px 0;
            flex-direction: column;
            justify-content: center;
            &:nth-child(2n) {
                background: #f9f9f9;
            }
        }
    }
    &-item.active {
        .cover {
            border-color: #dcb986;
        }
        .desc {
            color: #ba9153;
        }
    }
    &-item:hover {
        .cover {
            border-color: #dcb986;
        }
        .desc {
            color: #ba9153;
        }
    }
    .cover {
        width: 120px;
        height: 120px;
        border-radius: 73px;
        box-sizing: border-box;
        margin: 0 40px 0 0;
        border: 4px solid #fff;
        background-size: cover;
        background-position: center;
        @include media-mob {
            width: 120px;
            height: 120px;
            margin: 0 0 10px;
            border: none;
        }
    }
    .desc {
        font-size: 22px;
        font-family: Didot-Bold, Didot;
        font-weight: bold;
        color: #333333;
        line-height: 20px;
        @include media-mob {
            font-size: 20px;
        }
    }
}
.model-show {
    // flex: 1;
    height: 100%;
    max-height: 700px;
    position: relative;

    &.homepage {
        width: calc((100vh - 300px) * 1280 / 720);
        max-width: 1184px;
        max-height: 820px;
    }

    &.image-banner {
        margin-top: -20px;
        width: calc((100vh - 200px) * 1184 / 838);
        max-width: 1184px;
        max-height: 838px;
    }

    &.video {
        width: calc((100vh - 200px) * 1184 / 666);
        max-width: 1184px;
        max-height: 666px;
    }

    // &.margin-flexible {
    //     margin-left: calc(
    //         (1600px - 444px - (100vh - 300px) * 1068 / 756) / 5 * 3
    //     );
    // }

    @include media-mob {
        width: 100%;
        height: 238px;
        // height: auto;
        flex: none;
        max-height: none;
        &.mobile-current-show {
            height: auto;
            margin-bottom: 30px;
        }
    }
    .mobile-show-tab {
        padding: 0 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .mobile-tab-item {
            width: 111px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            background: #f8f8f8;
            font-family: Didot-Bold;
            font-size: 14px;
            color: #333333;
            font-weight: 700;
            margin: 0 1px 1px 0;
            &:nth-child(3n) {
                margin-right: 0;
            }
            &.active {
                background: rgba(220, 185, 134, 0.5);
            }
        }
    }

    .model-media__wrapper {
        // margin-top: 50px;
        position: relative;
        width: calc((100vh - 200px) * 1184 / 838);
        max-width: 1184px;

        &.video {
            margin-top: 72px;
            width: calc((100vh - 300px) * 1184 / 666);
            max-width: 1184px;
            max-height: 666px;
        }

        @include media-mob {
            width: 100%;
            max-width: 375px;
            margin-top: 0;
        }
    }

    .current-show {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        transform: translateY(-100%);
        .info {
            display: flex;
            color: #555;
            margin-right: 40px;
            font-family: Didot-Bold, Didot;
            font-size: 20px;
            letter-spacing: 0;
        }
        .name {
            margin-right: 40px;
        }
        .height,
        .three {
            margin-right: 20px;
        }
        .three {
            letter-spacing: 1px;
        }

        .prop {
            font-size: 20px;
            // font-family: "Arial-Black", Arial;
            font-family: Didot-Bold, Didot;
            font-weight: 900;
            line-height: 16px;
            margin-right: 6px;
        }
        .value {
            font-size: 20px;
            // font-family: "Arial-Black", Arial;
            font-family: Didot-Bold, Didot;
            font-weight: 900;
            line-height: 28px;
        }
    }
    .contact {
        display: flex;
        align-items: center;
        .icon {
            cursor: pointer;
            font-size: 16px;
            display: inline-block;
            margin-right: 30px;

            &:hover {
                color: #ba9153;
            }
        }
    }
    .current-show-info {
        // width: 534px;
        // height: 756px;
        width: calc((100vh - 200px) * 1184 / 838);
        max-width: 1184px;
        height: calc(100vh - 200px);
        max-height: 838px;
        overflow: hidden;
        color: #555;

        @include media-mob {
            transform: translateY(0);
            // height: auto;
            width: calc(100vw - 40px);
            margin: 10px auto 0;
            // max-height: auto;
        }
        // margin-top: 50px;
        // transform: translateY(-38px);
        .current-swiper {
            width: 100%;
            height: 100%;
            // @include media-mob {
            //     height: auto;
            // }
        }
        .swiper-item {
            width: 100%;
            height: 100%;
            &:hover {
                .profile-intro {
                    opacity: 1;
                }
            }
            &:nth-child(2n) {
                .profile-img {
                    text-align: left;
                }
            }
        }
        .profile-img {
            width: 100%;
            height: 100%;
            background: transparent center/cover no-repeat;
            position: relative;
            text-align: right;
        }
        .img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            @include media-mob {
                top: 0;
                transform: translateY(0);
            }
        }
        .profile-intro {
            text-align: left;
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 40px 40px 30px 40px;
            box-sizing: border-box;
            z-index: 10;
            font-size: 16px;
            font-family: Helvetica;
            color: #fff;
            line-height: 30px;
            opacity: 0;
            transition: all 0.4s;
            width: 100%;
            max-height: 200px;
            overflow: hidden;
            background: linear-gradient(
                180deg,
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0.61) 100%
            );
        }
    }
    .current-num {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 100%);
        font-size: 24px;
        font-family: Didot;
        color: #333333;
        line-height: 30px;

        .first-num {
            font-size: 14px;
        }
        .second-num {
            font-size: 22px;
            vertical-align: -webkit-baseline-middle;
        }

        @include media-mob {
            font-size: 22px;
            color: #000;
            letter-spacing: 0;
            // line-height: 22px;
            font-weight: 400;
            // bottom: -10px;
            transform: translateY(100%);

            span {
                display: inline-block;
            }
        }
    }

    .init-show {
        margin-top: 88px;
        height: 100%;
        max-height: 620px;
        position: relative;
        border-radius: 20px;
        @include media-mob {
            margin-top: 0;
        }
    }
    .cover {
        height: 100%;
        width: 100%;
        background-size: cover;
        border-radius: 20px;
        @include media-mob {
            border-radius: 0;
        }
    }
    .intro {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 20px;
        // transition: all 0.6s ease;
        @include media-mob {
            border-radius: 0;
        }
    }
    .intro-name {
        font-size: 42px;
        font-family: Arial-Black, Arial;
        // font-family: Didot-Bold, Didot;
        font-weight: bold;
        color: #fddaba;
        line-height: 30px;
        position: relative;
        padding-bottom: 20px;
        margin-bottom: 20px;
        &::after {
            content: "";
            display: block;
            position: absolute;
            height: 1px;
            width: 100%;
            bottom: 0;
            left: 0;
            right: 0;
            background: #fddaba;
        }
        @include media-mob {
            font-weight: bolder;
            font-size: 24px;
            letter-spacing: 0;
            line-height: 30px;
            padding-bottom: 10px;
            margin-bottom: 10px;
        }
    }
    .intro-other {
        display: flex;
        font-family: "Arial-Black", Arial;
        // font-family: Didot-Bold, Didot;
        font-size: 22px;
        color: #fddaba;
        letter-spacing: 0;
        margin-bottom: 92px;
        @include media-mob {
            width: 100%;
            flex-wrap: wrap;
            justify-content: center;
            margin-bottom: 0;
            font-size: 12px;
        }
        .three {
            letter-spacing: 1px;
            margin: 0 20px;
            @include media-mob {
                margin: 0 10px;
            }
        }
        // &-item {
        //     font-size: 22px;
        //     font-family: Arial-Black, Arial;
        //     font-weight: 900;
        //     color: #ffffff;
        //     line-height: 31px;
        //     display: flex;
        //     align-items: center;
        //     margin: 60px 45px 60px 0;
        //     &:last-child {
        //         margin-right: 0;
        //     }
        //     @include media-mob {
        //         font-size: 16px;
        //         margin: 20px 0 0;
        //         line-height: 1;
        //         width: 50%;
        //         font-weight: 500;
        //         font-family: Futura-Medium;
        //         box-sizing: border-box;
        //         padding-left: 80px;
        //         white-space: nowrap;
        //         &:nth-child(2n) {
        //             padding-left: 30px;
        //         }
        //     }
        // }
        .prop {
            margin: 0 13px 0 0;
            color: #fddaba;
            @include media-mob {
                margin-right: 6px;
            }
        }
    }
}
.intro-method {
    display: flex;
    align-items: center;
    @include media-mob {
        margin-top: 30px;
    }
    .icon {
        cursor: pointer;
        display: inline-block;
        font-size: 24px;
        margin: 0 20px 0 0;
        color: #fddaba !important;
        &:last-child {
            margin: 0;
        }
        @include media-mob {
            font-size: 16px;
            color: #fddaba !important;
        }
    }
}
</style>
<style lang="scss">
.swiper-wrapper {
    width: 0;

    @include media-mob {
        align-items: center;
    }
}
.prev,
.next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 40px;
    z-index: 10;
    color: #fff;

    @include media-mob {
        color: #ddd !important;
        font-size: 43px;
    }
}
.prev {
    left: 40px;
    @include media-mob {
        left: 4px;
    }
}
.next {
    right: 40px;
    @include media-mob {
        right: 4px;
    }
}
/* .video-player {
    width: 100%;
    height: 100%;
} */
</style>
